// recoil/selectors/authSelector.ts
import { selector } from "recoil";
import { authAtom } from "../atoms/authAtom";

// ユーザーが認証されているかを判定するセレクター
export const isAuthenticatedSelector = selector({
  key: "isAuthenticatedSelector", // セレクターのユニークなキー
  get: ({ get }) => {
    const auth = get(authAtom);
    return auth.isAuthenticated;
  },
});
